export default __webpack_public_path__ + "static/media/landing-image.e30980f3.png";